import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store";
import { Link, useHistory } from "react-router-dom";
import Title from "../common/Title";
import styled, { css } from "styled-components";
import { setNavItem } from "../../features/navigation/navigationSlice";
import Bullet from "./Bullet";
import NavList from "./NavList";

const NavContainer = styled.div`
  border: 1px solid #f1f1f1;
  border-radius: 12px 0 0 12px;
  padding: 10px;
  margin: 20px 0;
`;

const NavWrapper = styled.ul`
  margin: 0;
  padding: 0;
`;

export const NavBullet: any = styled(Bullet)`
  background: ${(p) => p.color};
`;

export default () => {
  const { t } = useTranslation("navigation");
  const navigation = useSelector((state: RootState) => state.navigation);
  const dispatch = useDispatch();
  const history = useHistory();

  const setActive = (item: any) => {
    dispatch(setNavItem(item));
  };

  return (
    <NavContainer>
      <Title>{t("title")}</Title>
      <NavWrapper>
        <NavList
          items={navigation.items}
          current={navigation.hoverItem}
          onHover={(item: any) => setActive(item)}
          onLeave={() => setActive(false)}
        />
      </NavWrapper>
    </NavContainer>
  );
};
